const LOCAL_PORT: string = process.env.REACT_APP_PORT || '3000';
const prsApiRootOverride = process.env.REACT_APP_PRS_API_URL;

interface ConfigType {
  urls: {
    apiRoot: string;
    wsRoot: string;
    prsApiRoot: string;
    chatUiRoot: string;
    ddRoot: string;
  };
  auth0: {
    redirectUri: string;
    logoutUri: string;
    clientId: string;
    domain: string;
    audience: string;
  };
  launchDarklyClientId: string;
}

interface ConfigsType {
  dev: ConfigType;
  testing: ConfigType;
  staging: ConfigType;
  production: ConfigType;
  localRemote: ConfigType;
  localStaging: ConfigType;
}

const configs: ConfigsType = {
  dev: {
    urls: {
      apiRoot: 'http://localhost:8080',
      wsRoot: 'ws://localhost:8080',
      prsApiRoot: prsApiRootOverride || 'https://payoff.staging.leaseend.com',
      chatUiRoot: 'http://localhost:3001',
      ddRoot: 'https://localhost:3000',
    },
    auth0: {
      redirectUri: `http://localhost:${LOCAL_PORT}/dashboard`,
      logoutUri: `http://localhost:${LOCAL_PORT}`,
      clientId: 'Mo5hQLQQ0Iet74rUqxu6mKxfaiitBaw4',
      domain: 'auth.leaseend.com',
      audience: 'https://api.leaseend.com/graphql',
    },
    launchDarklyClientId: '618400a0e330d26355a8e1e1',
  },
  testing: {
    urls: {
      apiRoot: 'https://staging.api.leaseend.com',
      wsRoot: 'wss://staging.api.leaseend.com',
      prsApiRoot: 'https://payoff.staging.leaseend.com',
      chatUiRoot: 'https://chat.staging.leaseend.com',
      ddRoot: 'https://dd.staging.leaseend.com',
    },
    auth0: {
      redirectUri: 'https://testing.app.leaseend.com/dashboard',
      logoutUri: 'https://testing.app.leaseend.com',
      clientId: 'Mo5hQLQQ0Iet74rUqxu6mKxfaiitBaw4',
      domain: 'auth.leaseend.com',
      audience: 'https://api.leaseend.com/graphql',
    },
    launchDarklyClientId: '618400a0e330d26355a8e1e1',
  },
  staging: {
    urls: {
      apiRoot: 'https://api.staging.leaseend.com',
      wsRoot: 'wss://api.staging.leaseend.com',
      prsApiRoot: 'https://payoff.staging.leaseend.com',
      chatUiRoot: 'https://chat.staging.leaseend.com',
      ddRoot: 'https://dd.staging.leaseend.com',
    },
    auth0: {
      redirectUri: 'https://app.staging.leaseend.com/dashboard',
      logoutUri: 'https://app.staging.leaseend.com',
      clientId: 'Mo5hQLQQ0Iet74rUqxu6mKxfaiitBaw4',
      domain: 'auth.leaseend.com',
      audience: 'https://api.leaseend.com/graphql',
    },
    launchDarklyClientId: '618400a0e330d26355a8e1e1',
  },
  production: {
    urls: {
      apiRoot: 'https://api.leaseend.com',
      wsRoot: 'wss://api.leaseend.com',
      prsApiRoot: 'https://payoff.leaseend.com',
      chatUiRoot: 'https://chat.leaseend.com',
      ddRoot: 'https://dd.leaseend.com',
    },
    auth0: {
      redirectUri: 'https://app.leaseend.com/dashboard',
      logoutUri: 'https://app.leaseend.com',
      clientId: 'Mo5hQLQQ0Iet74rUqxu6mKxfaiitBaw4',
      domain: 'auth.leaseend.com',
      audience: 'https://api.leaseend.com/graphql',
    },
    launchDarklyClientId: '618400a0e330d26355a8e1e2',
  },
  localRemote: {
    urls: {
      apiRoot: 'https://api.staging.leaseend.com',
      wsRoot: 'wss://api.staging.leaseend.com',
      prsApiRoot: 'https://payoff.leaseend.com',
      chatUiRoot: 'https://chat.leaseend.com',
      ddRoot: 'https://dd.staging.leaseend.com',
    },
    auth0: {
      redirectUri: `http://localhost:${LOCAL_PORT}/dashboard`,
      logoutUri: `http://localhost:${LOCAL_PORT}`,
      clientId: 'Mo5hQLQQ0Iet74rUqxu6mKxfaiitBaw4',
      domain: 'auth.leaseend.com',
      audience: 'https://api.leaseend.com/graphql',
    },
    launchDarklyClientId: '618400a0e330d26355a8e1e2',
  },
  localStaging: {
    urls: {
      apiRoot: 'https://staging.api.leaseend.com',
      wsRoot: 'wss://staging.api.leaseend.com',
      prsApiRoot: 'https://payoff.staging.leaseend.com',
      chatUiRoot: 'https://chat.staging.leaseend.com',
      ddRoot: 'https://dd.staging.leaseend.com',
    },
    auth0: {
      redirectUri: `http://localhost:${LOCAL_PORT}/dashboard`,
      logoutUri: `http://localhost:${LOCAL_PORT}`,
      clientId: 'Mo5hQLQQ0Iet74rUqxu6mKxfaiitBaw4',
      domain: 'auth.leaseend.com',
      audience: 'https://api.leaseend.com/graphql',
    },
    launchDarklyClientId: '618400a0e330d26355a8e1e1',
  },
};

export const getEnv = () => process.env.REACT_APP_STAGE || process.env.NODE_ENV;
export const isLocal = getEnv() === 'dev' || getEnv() === 'development';
export const isStaging = getEnv() === 'staging';
export const isProd = getEnv() === 'production';

export const marketUrl = (() => {
  if (isLocal) {
    return 'http://localhost:3002';
  }
  return `https://${isProd ? 'www.' : 'staging.'}leaseend.com`;
})();

const config = {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...configs[(process.env.REACT_APP_STAGE || process.env.NODE_ENV) as keyof ConfigsType],
};

export const getDD2DealsUrl = () => new URL('/deals', config.urls.ddRoot).toString();

export default config;
